import React from 'react';

const CheckIcon = ({ size = 16, color = '#FFFFFF', useThemeColor = false, ...props }) => {
    const fillColor = useThemeColor ? 'var(--color-grt-primary)' : color;
    
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M438.272 741.632L193.28 496.64l67.008-67.008 177.984 177.984 325.376-325.376 67.008 67.008-392.32 392.32z"
                fill={fillColor}
            />
        </svg>
    );
};

export default CheckIcon; 